import DetailPeriodicPage from "./DetailPeriodicPage";
export default DetailPeriodicPage;
